<template>
  <div class="header-warp">
    <div class="pc-header">
      <div class="site-nav">
        <div class="warp">
          <!-- 原先绑定用户名的格式：userInfo.name -->
          <div class="left">
            <i class="location-icon"></i>
            <span class="current-location">{{ city_location.label || "保山" }}</span>
            <span class="change-location-btn" @click="openChangeLocation()"
              >[切换]</span
            >
            <router-link to="/shop_mall/index"
              ><div class="gohome icon-home">首页</div></router-link
            >
            <!-- 切换平台：零售商城 大宗集采商城 -->
            <div>
              <div class="gohome" style="margin-left: 20px" @click="toPlatform">
                {{ platformText }}
              </div>
            </div>
          </div>
          <!-- <div class="left" v-else>
            <i class="location-icon"></i>
            <span class="current-location">{{city_location}}</span>
            <span class="change-location-btn" @click="openChangeLocation()">[切换]</span>
          </div> -->
          <div class="notice" v-if="noticeList.length > 0">
            <div class="noticeBox">
              <div class="noticeTitle">
                <img src="../../../static/image/notice.gif" alt="" />
                <span>通知公告:</span>
              </div>
              <swiper
                class="noticeBox-swiper"
                :options="{
                  autoplay: true, // 可选选项，自动滑动
                  speed: 1000,
                  autoplay: {
                    delay: 5000,
                    stopOnLastSlide: false /* 触摸滑动后是否继续轮播 */,
                    disableOnInteraction: false,
                  },
                }"
              >
                <swiper-slide
                  class="noticeBox-swiper-box"
                  v-for="(item, index) in noticeList"
                  :key="index"
                  @click="goToDetail(item.noticeId)"
                >
                  <h3
                    style="font-size: 14px"
                    class="medium overflow font-color-FF7 cur-poi"
                    @click="goToDetail(item.noticeId)"
                  >
                    {{ item.noticeTitle }}
                  </h3>
                </swiper-slide>
              </swiper>
              <!-- <el-carousel arrow="nerver" height="42px" loop indicator-position="none" :interval="3000" v-if="noticeList.length">
                <el-carousel-item v-for="item in noticeList" :key="item.noticeId">
                  <h3 style="font-size:14px;" class="medium overflow font-color-FF7 cur-poi" @click="goToDetail(item.noticeId)">{{ item.noticeTitle }}</h3>
                </el-carousel-item>
              </el-carousel>
              <div class="mar-left-10" v-else>无</div> -->
            </div>
          </div>
          <div class="right">
            <!-- <div class="item">
              <i class="icon-Application-in"></i>
              <a class="hover-item" @click="applySettle"><span class="item_text">申请入驻</span></a>
            </div> -->
            <div v-if="userInfo.phone" class="userInfoMain">
              <!-- <div class="welcome" @mouseover="isShowOut = true" @mouseleave="isShowOut = false">
                {{userInfo.name}}
                <span class="iconfont hoverShowOut">&#xe695;</span>
                <div class="outLogin" v-show="isShowOut" @click="outLoginBtn">退出登录</div>
              </div> -->
              <div
                class="item item-select"
                style="padding: 0 20px; width: 200px"
                @mouseover="isShowOut = true"
                @mouseleave="isShowOut = false"
                @click="goToUserInfo"
              >
                <span class="hover-item">
                  <span class="headImg">
                    <img
                      v-if="userInfo.headImage"
                      style="height: 100%"
                      :src="userInfo.headImage"
                      alt=""
                    />
                    <img
                      v-else
                      style="height: 100%"
                      src="https://static.xhngyl.com/xhngyl-platform-gy/avatar/2021-08-24/4588b24faf4c4588a0878eeef5fcd4b3-avatar.png"
                      alt=""
                    />
                  </span>
                  <span
                    class="item_text"
                    style="
                      display: inline-block;
                      width: 100px;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                    "
                    >{{
                      userInfo.name ? userInfo.name : userInfo.account
                    }}</span
                  >
                  <!-- <div class="vipLogo">PLUS</div> -->
                  <i class="ico-arrow el-icon-arrow-down"></i>
                </span>
                <div class="cart-box" v-show="isShowOut">
                  <div class="user-bar">
                    <div
                      style="
                        cursor: pointer;
                        display: flex;
                        justify-content: left;
                      "
                      @click="$router.push({ name: 'userInfo' })"
                    >
                      <span class="headImg">
                        <img
                          v-if="userInfo.headImage"
                          style="height: 100%"
                          :src="userInfo.headImage"
                          alt=""
                        />
                        <img
                          v-else
                          style="height: 100%"
                          :src="headImage"
                          alt=""
                        />
                      </span>
                      <div class="user-bar-name">
                        <!-- <div class="vipLogo">PLUS</div> -->
                        <div
                          style="
                            width: 50px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                          "
                        >
                          {{ userInfo.name ? userInfo.name : userInfo.account }}
                        </div>
                      </div>
                    </div>

                    <div class="outLogin" @click.stop="outLoginBtn">
                      <span> 退出 </span>
                    </div>
                  </div>
                  <ul>
                    <li
                      @click.stop="goToUserInfo"
                      class="icon-Personal-information"
                    >
                      个人信息
                    </li>
                    <li @click.stop="goToMessage" class="icon-xiaoxizhongxin">
                      我的消息
                    </li>
                    <li @click.stop="goToUserOrder" class="icon-The-order">
                      我的订单
                    </li>
                    <li @click.stop="goToUserAddress" class="icon-positioning">
                      收货地址
                    </li>
                    <li
                      @click.stop="gotoUserCollection"
                      class="icon-collection-01"
                    >
                      我的收藏
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div style="display: flex; alien-items: center" v-else>
              <span class="header-login-btn" @click="loginBtn(2)"
                >[请登录]</span
              >
              <!-- <span class="header-register-btn" @click="loginBtn(1)"><img src="../../assets/images/gift.png" alt="" srcset=""> 注册立享新人礼</span> -->
              <span
                class="header-register-btn"
                @click="loginBtn(1)"
                style="margin-right: 60px; cursor: pointer"
                >[注册]</span
              >
            </div>

            <div class="item">
              <i class="icon-The-order"></i>
              <a class="hover-item" @click="goToUserOrder"
                ><span class="item_text">我的订单</span
                ><span v-if="orderTotal">(</span>
                <span v-if="orderTotal" style="color: #ff4747">{{
                  orderTotal
                }}</span>
                <span v-if="orderTotal">)</span></a
              >
            </div>
            <!-- <div
              class="item"
              @mouseover="isShowSecondMenu = true"
              @mouseleave="isShowSecondMenu = false"
            >
              <i class="icon-Application-in" style="font-size: 16px"></i>
              <a class="hover-item">
                <span class="item_text">企业中心</span>
                <i class="ico-arrow el-icon-arrow-down"></i>
              </a>
              <div class="secondMenu" v-if="isShowSecondMenu">
                <div class="item1" @click="getCollaborate">
                  <img src="../../assets/images/setUpShop@2x.png" alt="" />
                  <div>一键开店</div>
                </div>
                <div class="item2" @click="getMerchantLogin">
                  <img src="../../assets/images/loginShop@2x.png" alt="" />
                  <div>登录企业中心</div>
                </div>
              </div>
            </div> -->
            <div class="item item-select">
              <span class="hover-item">
                <i
                  class="icon-Customer-service-hotline"
                  style="font-size: 20px"
                ></i>
                <span class="item_text">平台客服</span>
                <i class="ico-arrow el-icon-arrow-down"></i>
              </span>
              <div class="cart-box user-box" style="width: 440px; left: -160px">
                <div
                  class="online_help_box2"
                  style="
                    display: flex;
                    justify-content: space-around;
                    align-items: center;
                    flex-direction: row;
                  "
                >
                  <div style="text-align: center">
                    <img
                      style="width: 150px; margin: 0 auto"
                      src="../../assets/images/qrcode.png"
                      alt=""
                      srcset=""
                    />
                    <p
                      style="
                        text-align: center;
                        color: #000000;
                        font-size: 14px;
                      "
                    >
                      扫码联系微信客服-牛牛
                    </p>
                  </div>
                  <div style="text-align: center">
                    <img
                      style="width: 150px; margin: 0 auto"
                      src="../../assets/images/qrcode2.png"
                      alt=""
                      srcset=""
                    />
                    <p
                      style="
                        text-align: center;
                        color: #000000;
                        font-size: 14px;
                      "
                    >
                      扫码联系微信客服-链链
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="item item-select">
              <span class="hover-item">
                <i class="icon-Mobile-phone" style="font-size: 20px"></i>
                <span class="item_text">移动端</span>
                <i class="ico-arrow el-icon-arrow-down"></i>
              </span>
              <div
                class="cart-box user-box"
                style="width: auto; padding: 0; right: 0; left: -122px"
              >
                <div class="QR-container" style="padding: 20px">
                  <div v-for="(item, index) in QR_code" :key="index">
                    <img :src="item.code" alt="" />
                    <div>
                      <img :src="item.icon" alt="" />
                      <span>{{ item.text }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <router-link to="/helpCenter">
              <div class="item">
                <span class="item_text">帮助中心</span>
              </div>
            </router-link>
            <!-- <div class="item item-select">
              <span class="hover-item" @click="goToShopCart">
                <i class="icon-The-shopping-cart"></i>
                <span class="item_text">采购单</span>
                <span v-if="isShowNum">(<b v-text="cartNumber === 0 ? '0' : cartNumber"></b>)</span>
                <i class="ico-arrow el-icon-arrow-down"></i>
              </span>
              <div v-if="!isLogin" class="cart-box cart-no-login">
                <a class="btn" @click="loginBtn">登录</a>
                <p class="p">登录后查看商品</p>
              </div>
              <div v-else-if="shoppingCart.length === 0" class="cart-box cart-no-data">
                <p class="p">采购单还没有商品，赶紧选购吧！</p>
              </div>
              <div v-else class="cart-box cart-list">
                <div v-for="shop in shoppingCart" :key="shop.shopId">
                  <dl v-for="(item, index) in shop.skus" :key="index" v-show="index<5">
                    <dt>
                      <div class="cartImgBox" style="width: 42px;height: 42px;background: #F5F5F5;" @click="$router.push('/shopping-trolley')">
                        <img :src="item.image" alt="">
                      </div>
                    </dt>
                    <dd>
                      <h4 class="h4" @click="$router.push('/shopping-trolley')">{{item.productName}}</h4>
                      <p>{{item.SKU}}</p>
                      <span>￥{{item.price}}</span>
                      <a class="btn-del" @click="deleteCartItem(item)">删除</a>
                    </dd>
                  </dl>
                </div>
                <a class="btn-view-all" @click="goToShopCart" v-if="cartNumber>5">查看全部</a>
              </div>
            </div> -->
            <!-- <div class="item item-select">
              <span class="hover-item">
                <i class="icon-my"></i><span class="item_text">我的</span><i class="ico-arrow el-icon-arrow-down"></i></span>
              <div class="cart-box user-box">
                <ul>
                  <li @click="goToUserInfo">个人信息</li>
                  <li @click="goToUserOrder">我的订单</li>
                  <li @click="goToUserAddress">收货地址</li>
                  <li @click="gotoUserCollection">我的收藏</li>
                </ul>
              </div>
            </div> -->
          </div>
        </div>
      </div>

      <div class="fixed-help-box">
        <div class="fixed-help-box-outer">
          <div class="fixed-help-box-item" @click="goToShopCart">
            <span class="icon-The-shopping-cart">
              <span
                v-if="isShowNum && cartNumber !== 0"
                v-text="cartNumber"
              ></span>
            </span>
            <span>{{platform =="b2c"?"购物车":"采购单"}}</span>
          </div>
          <div
            class="fixed-help-box-item"
            @mouseover="showHelp = true"
            @mouseout="showHelp = false"
          >
            <span class="icon-The-phone"></span>
            <span>客服热线</span>
            <div class="online_help_box" v-show="showHelp">
              <div class="imgbox">
                <img
                  src="../../assets/images/online_help.png"
                  alt=""
                  srcset=""
                />
              </div>
              <div class="text">
                <p>企业客服</p>
                <span>上班时间: 9:00 ~ 18:00</span>
                <span>客服热线 400-082-3688</span>
              </div>
            </div>
          </div>
          <div
            class="fixed-help-box-item"
            @mouseover="showServer = true"
            @mouseout="showServer = false"
          >
            <span class="icon-Customer-service-hotline"></span>
            <span>平台客服</span>
            <div class="online_help_box2" v-show="showServer">
              <div>
                <img
                  style="width: 150px"
                  src="../../assets/images/qrcode.png"
                  alt=""
                  srcset=""
                />
                <p style="text-align: center; color: #000000; font-size: 14px">
                  扫码联系微信客服-牛牛
                </p>
              </div>
              <div>
                <img
                  style="width: 150px"
                  src="../../assets/images/qrcode2.png"
                  alt=""
                  srcset=""
                />
                <p style="text-align: center; color: #000000; font-size: 14px">
                  扫码联系微信客服-链链
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="提示" :visible.sync="outLoginDialog" width="30%">
      <span>确定退出登录吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="outLoginDialog = false">取 消</el-button>
        <el-button type="primary" @click="outLogin">确 定</el-button>
      </span>
    </el-dialog>
    <div class="flexLeft" @click="toBack">
      <p class="back">返回上一页</p>
      <i class="el-icon-download"></i>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { listSearchMixin } from "@/config/mixin";
import Cookie from "js-cookie";
import api from "@/api";
import { Encrypt } from "@/util/secret";
import changeLocation from "./changeLocation.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import { userInfo } from "../../store/getter";
import { BASEURL_PRO_ENTERPRISE, download } from "@/modules/http.js";
export default {
  mixins: [listSearchMixin],
  name: "siteNav",
  // components:[changeLocation,swiper, swiperSlide],
  components: {
    swiper,
    swiperSlide,
    changeLocation,
  },
  props: {
    componentContent: {
      type: Object,
    },
  },
  computed: {
    ...mapGetters(["userInfo", "shoppingCart", "cartNumber", "city_location"]),
    
  },
  data() {
    return {
      headImage:
        "https://static.xhngyl.com/xhngyl-platform-gy/avatar/2021-08-24/4588b24faf4c4588a0878eeef5fcd4b3-avatar.png",
      isShowSecondMenu: false,
      orderTotal: 0,
      showServer: false,
      showHelp: false,
      isShowOut: false,
      menuOpen: false,
      isLogin: true,
      outLoginDialog: false,
      isShowNum: false,
      deleteOpt: {
        visiable: false,
      },
      swiperOption: {
        autoplay: true, // 可选选项，自动滑动
        speed: 1000,
        autoplay: {
          delay: 5000,
          stopOnLastSlide: false /* 触摸滑动后是否继续轮播 */,
          disableOnInteraction: false,
        },
        loop: true,
      },
      proList: [],
      noticeList: [],
      QR_code: [
        // {
        //   code: "../../../static/image/QR-public.png",
        //   icon: "../../../static/image/iPhone-icon.png",
        //   text: "iphone",
        // },
        {
          code: "../../../static/image/code_dev.png",
          icon: "../../../static/image/Android-icon.png",
          text: "Android",
        },
      ],
      platform: "b2c",
      platformText: "大宗集采商城",
    };
  },
  created() {
    if (Cookie.get("token")) {
      this.isShowNum = true;
      this.getTrolleyList();
      this.getGongGaoAll();
      this.getOrderList();
    }
    if (download == "dev") {
      this.QR_code[0].code = "../../../static/image/code_dev.png";
    } else if (download == "pre") {
      this.QR_code[0].code = "../../../static/image/code_pre.png";
    } else {
      this.QR_code[0].code = "../../../static/image/code_prod.png";
    }
    this.platform = "b2c";
    if (this.platform == "b2b") {
      this.platformText = "零售商城";
      this.setPlatform("b2b")
      localStorage.setItem("platform", "b2b");
    } else if (this.platform == "b2c") {
      this.platformText = "大宗集采商城";
      this.setPlatform("b2c")
      localStorage.setItem("platform", "b2c");
    }
  },
  // mounted(){
  //   this.userInfoData = JSON.parse(JSON.stringify(this.userInfo));
  // },
  methods: {
    ...mapMutations({
      setUserInfo: "SET_USERINFO",
      setCartNumber: "SET_CARTNUMBER",
      setShoppingCart: "SET_SHOPPINGCART",
      setNewAddress: "SET_NEWADDRESS",
      setAreaCode: "SET_AREACODE",
      setNoticeId: "SET_NOTICEID",
      setLocation: "SET_LOCATION",
      setPlatform: "SET_platform"
    }),
    toBack() {
      window.location.href = document.referrer;
      window.history.back(-1);
    },
    toPlatform() {
      let platform = this.$store.state.platform
      console.log(this.$store.state.platform)
      if(platform == "b2b"){
        this.platform == "b2b"
        this.platformText = "零售商城";
        this.setPlatform("b2c")
        localStorage.setItem("platform", "b2c");
        console.log(this.$store.state.platform)
        this.$router.push({
          path: "/shop_mall",
        });
      }else if(platform == "b2c"){
        this.platform == "b2c"
        this.platformText = "大宗集采商城";
        this.setPlatform("b2b")
        localStorage.setItem("platform", "b2b");
        console.log(this.$store.state.platform)
        this.$router.push({
          path: "/",
        });
      }
    },
    // 获取订单列表
    getOrderList() {
      let self = this;
      let params = {
        url: api.getOrderList + `?page=1&pageSize=999`,
        method: "GET",
        data: {},
      };
      self.sendReq(params, (res) => {
        if (res.code === "200") {
          self.orderTotal = res.data.total;
        }
      });
    },
    // 采购单列表
    async getTrolleyList() {
      const vm = this;
      const params = {
        url: api.getTrolleyList,
        method: "GET",
      };
      vm.sendReq(params, (res) => {
        const d = res.data;
        let cartNumber = 0;
        if (d.length) {
          d.forEach((j) => {
            cartNumber = cartNumber + j.skus.length;
          });
        }
        this.setShoppingCart(d);
        this.setCartNumber(cartNumber);
      });
    },
    // 公告
    getGongGaoAll() {
      const params = {
        url: api.getGongGaoAll,
        method: "GET",
      };
      this.sendReq(params, (res) => {
        if (res.code === "200") {
          this.noticeList = res.data;
        } else {
          this.$message.warning(res.message);
        }
      });
    },
    // 删除单个商品
    deleteCartItem(item) {
      // const id = info.skuId
      let ids = [];
      ids.push(item.skuId);
      let params;
      params = {
        url: api.deleteGoods,
        method: "DELETE",
        data: {
          ids: ids,
        },
      };
      this.sendReq(params, (res) => {
        let id = item.skuId;
        this.shoppingCart.map((j) => {
          j.skus.map((k) => {
            if (k.skuId === id) {
              j.skus.splice(
                j.skus.findIndex((item) => item.skuId === id),
                1
              );
            }
          });
        });
        this.setCartNumber(this.cartNumber - 1);
        this.getTrolleyList();
        this.$message.success("删除成功");
      });
    },
    outLoginBtn() {
      this.outLoginDialog = true;
    },
    outLogin() {
      this.outLoginDialog = false;
      Cookie.remove("token");
      Cookie.remove("account");
      Cookie.remove("needCheckPass");
      this.setUserInfo({});
      this.setCartNumber("");
      this.setShoppingCart({});
      this.setNewAddress({});
      this.setAreaCode([]);
      this.$router.push({ path: "/login", query: { type: 2 } });
    },
    // 申请入驻
    applySettle() {
      console.log(Cookie.get("token"));
      let token = Encrypt(Cookie.get("token"));
      let username = encodeURI(this.userInfo.name);
      let userInfo = encodeURI(username);
      // let test = Decrypt(token)
      console.log(username);
      // window.open(`${api.settled}?username=${userInfo}&user=${token}`)
      window.open(`${api.settled}?path=MerchantCheck`);
    },
    goToUserInfo() {
      this.$router.push({ path: "/shop_mall/userInfo" });
    },
    goToMessage() {
      this.$router.push({ path: "/shop_mall/message" });
    },
    goToUserOrder() {
      this.$router.push({ path: "/shop_mall/myOrder" });
    },
    loginBtn(type) {
      this.$router.push({ path: "/login", query: { type: type } });
    },
    goToUserAddress() {
      this.$router.push({ path: "/shop_mall/signingAddress" });
    },
    gotoUserCollection() {
      this.$router.push({ path: "/shop_mall/favorites" });
    },
    goToShopCart() {
      this.$router.push({ path: "/shop_mall/shopping-trolley" });
    },
    hover() {
      this.isShowOut = true;
    },
    openChangeLocation() {
      const h = this.$createElement;
      this.$msgbox({
        title: "区域选择",
        customClass: "changelocation-box",
        // message: h('div',null,[changeLocation]),
        message: h(changeLocation, {
          props: {
            setLocation: this.setLocation,
            city_location: this.city_location,
            finish:() => {
              this.$msgbox.close();
              window.location.href = window.location.href;
            }
          },
        }),
        showCancelButton: false,
        showConfirmButton: false,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = "切换中...";
            setTimeout(() => {
              done();
              setTimeout(() => {
                instance.confirmButtonLoading = false;
              }, 300);
            }, 200);
          } else {
            done();
          }
        },
      });
    },
    // 跳转到公告详情
    goToDetail(id) {
      this.$router.push({
        path: "/notificationDetails",
        query: {
          id: id,
        },
      });
      this.setNoticeId(id);
    },
    getMerchantLogin() {
      window.open(BASEURL_PRO_ENTERPRISE);
    },
    // 申请合作跳转
    getCollaborate() {
      let params = {
        url: api.enterprisePass,
        method: "POST",
        data: {},
      };
      this.sendReq(params, (res) => {
        if (res.code == 20004) {
          this.loginBtn(2);
          this.$message.warning("请先登录");
        } else if (res.code == 40017) {
          this.$confirm({
            title: "机构认证",
            content: (h) => {
              return (
                <div>
                  <div style="font-size:14px;margin-bottom:10px;">
                    您当前还没有机构认证,或者未通过机构认证,
                    <span style="font-size:15px;margin-left:2px;color:#ff4d4f;">
                      需认证成功后才可以申请合作
                    </span>
                  </div>
                  <div>
                    您也可以从
                    <span style="font-size:12px;margin:0 4px;color:#999;">
                      个人中心-机构认证
                    </span>
                    进入提交认证,未认证不会影响您浏览商品
                  </div>
                </div>
              );
            },
            icon: "exclamation-circle",
            width: 600,
            cancelText: "下次再说",
            okText: "立即认证",
            okType: "danger",
            onOk: () => {
              this.$router.push({
                path: "/companyCertificate",
              });
            },
          });
        } else {
          this.$router.push({ path: "/shopInfr" });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.flexLeft {
  // background-color: #ff7b0b;
  background-color: #fff;
  width: 130px;
  height: 130px;
  border-radius: 50%;
  position: fixed !important;
  left: -60px;
  top: 38%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 5px;
  // flex-direction:column;
  box-shadow: 2px 2px 15px rgba(0, 0, 0, 0.2);
  transition: 0.5s all ease;
  .back {
    display: block;
    width: 20px;
    height: 100%;
    margin-top: 15px;
    font-size: 14px;
  }
  i {
    font-size: 40px;
    color: #5d6063;
    // margin-right: 15px;
    transform: rotate(90deg);
    transition: 0.5s all ease;
  }
  &:hover {
    cursor: pointer;
    background-color: #ff7b0b;
    transition: 0.5s all ease;
    width: 130px;
    height: 130px;
    border-radius: 50%;
    position: fixed;
    left: -60px;
    top: 38%;
    i {
      font-size: 54px;
      color: #fff;
      margin-right: 10px;
      transition: 0.5s all ease;
    }
  }
}
.noticeBox-swiper {
  height: 45px;
}
.fixed-help-box {
  z-index: 999;
  display: flex;
  width: 95px;
  height: 285px;
  background: #ffffff;
  box-shadow: 0px 5px 10px 0px rgba(231, 234, 235, 0.93);
  position: fixed;
  top: 50%;
  margin-top: -140px;
  right: 0px;
  align-items: stretch;
  padding: 0 16px;
  .fixed-help-box-outer {
    display: flex;
    flex: 1;
    flex-direction: column;
    height: 100%;
    align-items: stretch;
    .fixed-help-box-item {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      border-bottom: 1px solid #e5e5e5;
      cursor: pointer;
      position: relative;
      .icon-The-shopping-cart {
        position: relative;
        span {
          position: absolute;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 13px;
          background: #ff4747;
          color: #fff;
          width: 20px;
          height: 19px;
          right: -15px;
          top: -5px;
        }
      }
      span {
        font-size: 14px;
        color: #606266;
      }
      & > span:first-child {
        font-size: 24px;
        margin-bottom: 5px;
      }
      & > span:first-child:before {
        font-size: 24px;
        color: #606266;
      }
      .online_help_box {
        width: 205px;
        height: 96px;
        background: #f77b0b;
        border-radius: 4px;
        position: absolute;
        right: 87px;
        top: 0;
        display: flex;
        padding: 16px 0 15px 23px;
        color: #ffffff;
        span {
          color: #ffffff;
        }
        .imgbox {
          height: 25px;
          width: 24px;
          margin-right: 6px;
          img {
            display: inline-block;
            height: 25px;
          }
        }
        .text {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          p {
            height: 25px;
            display: flex;
            align-items: center;
            width: 60px;
            font-size: 14px;
            font-weight: bold;
          }
          span {
            font-size: 12px;
          }
        }
      }
      .online_help_box:before {
        content: "";
        display: inline-block;
        width: 0;
        height: 0;
        border: 8px solid transparent;
        border-left-color: #f77b0b;
        position: absolute;
        right: -16px;
        margin-top: -8px;
        top: 50%;
      }
      .online_help_box2 {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: row;
        width: 390px;
        height: auto;
        background: #ffffff;
        border-radius: 4px;
        position: absolute;
        right: 87px;
        top: 0;
        display: flex;
        padding: 16px 30px;
        color: #ffffff;
        div {
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
        }
        span {
          color: #ffffff;
        }
        .imgbox {
          height: 25px;
          width: 24px;
          margin-right: 6px;
          img {
            display: inline-block;
            height: 25px;
          }
        }
        .text {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          p {
            height: 25px;
            display: flex;
            align-items: center;
            width: 60px;
            font-size: 12px;
            font-weight: bold;
            margin-top: 5px;
          }
          span {
            font-size: 12px;
          }
        }
      }
      .online_help_box2:before {
        content: "";
        display: inline-block;
        width: 0;
        height: 0;
        border: 8px solid transparent;
        border-left-color: #ffffff;
        position: absolute;
        right: -16px;
        margin-top: -8px;
        top: 20%;
      }
    }
    .fixed-help-box-item:last-child {
      border-bottom: none;
    }
    .fixed-help-box-item:hover {
      & > span {
        color: #f77b0b;
      }
      & > span:first-child:before {
        color: #f77b0b;
      }
    }
  }
}
.vipLogo {
  width: 47px;
  height: 20px;
  background: #333333;
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #f2c222;
  margin: 0 5px 0 0;
}
.userInfoMain {
  // padding: 0 40px;
  .headImg {
    width: 32px;
    height: 32px;
    overflow: hidden;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 5px;
  }
  .cart-box {
    width: 200px;
    .user-bar {
      height: 88px;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #e5e5e5;
      padding: 0 18px;
      .headImg {
        width: 54px;
        height: 54px;
        margin-right: 10px;
      }
      .user-bar-name {
        flex: 1;
        height: 60px;
        display: flex;
        justify-content: center;
        flex-direction: column;
        div:last-child {
          margin-top: 2px;
          height: 20px;
          line-height: 20px;
        }
      }
      .outLogin {
        width: 54px;
        height: 60px;
        margin-top: 25px;
        line-height: 60px;
        color: #ff7800;
        display: flex;
        align-items: flex-start;
        justify-content: flex-end;
        padding: 10px 5px;
        cursor: pointer;
        span {
          height: 20px;
          line-height: 20px;
          // padding-top: 2px;
        }
      }
    }
    ul {
      li {
        display: flex;
        align-items: center;
        padding: 17px 45px;
        font-size: 14px;
        color: #333;
        cursor: pointer;
      }
      li:before {
        margin-right: 10px;
        font-size: 18px;
        color: #777;
      }
      li:hover {
        background: #ff7d0b21;
      }
      li:hover,
      li:hover:before {
        color: #f77b0b;
      }
    }
  }
}
.site-nav {
  height: 46px;
  background: #fff;
  line-height: 46px;
  font-size: 14px;
  .warp {
    display: flex;
    justify-content: space-between;
  }
  .welcome {
    position: relative;
    .outLogin {
      top: 50px;
      left: 50px;
      position: absolute;
      width: 100%;
      z-index: 999;
      background: #ffffff;
      text-align: center;
      cursor: pointer;
      box-shadow: 0 0 20px #cccccc;
    }
  }
  .left {
    display: flex;
    align-items: center;
    span {
      color: #666666;
      cursor: pointer;
    }
    span:hover {
      color: $mainColor;
    }
    .location-icon {
      display: inline-block;
      width: 16px;
      height: 14px;
      margin-right: 2px;
      margin-top: -2px;
      background: url(../../../static/image/location-icon.png) no-repeat center;
      background-size: contain;
    }
    .current-location {
      margin-right: 6px;
    }
    .change-location-btn {
      margin-right: 26px;
    }
    .gohome {
      display: flex;
      align-items: center;
      cursor: pointer;
      font-size: 14px;
      padding-top: 1px;
    }
    .gohome:hover {
      color: #ff7b0b;
    }
    .gohome:before {
      margin-right: 2px;
      font-size: 16px;
      position: relative;
      top: -1px;
    }
  }
  .header-login-btn,
  .header-register-btn {
    cursor: pointer;
    color: #ff7b0b;
  }
  .header-login-btn:hover,
  .header-register-btn:hover {
    color: #ff7d0bc0;
  }
  .header-register-btn {
    color: #ff4747;
    display: flex;
    align-items: center;
    img {
      width: 17px;
      margin-right: 4px;
    }
  }
  .header-register-btn:hover {
    color: #ff4747cc;
  }
  .header-register-btn {
    margin-right: 39px;
  }
  .header-login-btn {
    margin-right: 10px;
  }
  .notice {
    float: left;
    width: 280px;
    margin-left: 30px;
    .noticeBox {
      display: flex;
      width: 100%;
      .noticeTitle {
        display: flex;
        align-items: center;
        height: 45px;
        width: 86px;
        img {
          width: 22px;
          height: 22px;
          margin-right: 3px;
        }
      }
      .noticeBox-swiper {
        flex: 1;
      }
      .el-carousel {
        flex: 1;
        margin-left: 10px;
      }
    }
  }
  .right {
    float: right;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .item {
      padding: 0 15px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      .secondMenu {
        position: absolute;
        top: 45px;
        z-index: 999;
        width: 277px;
        height: 160px;
        background-color: #fff;
        display: flex;
        align-items: center;
        box-shadow: 0px 5px 10px 0px rgba(231, 234, 235, 0.93);
        border-radius: 4px;

        .item1 {
          position: absolute;
          left: 50px;
          text-align: center;
          cursor: pointer;
        }

        .item2 {
          position: absolute;
          right: 40px;
          text-align: center;
          cursor: pointer;
        }

        > div {
          > div {
            padding-top: 11px;
            font-size: 14px;
            font-family: MicrosoftYaHei;
            color: #333333;
            line-height: 19px;
          }

          > img {
            width: 50px;
            height: 50px;
          }
        }
      }
      .hover-item {
        display: flex;
        align-items: center;
        justify-content: center;
        .item_text {
          margin: 0 4px;
          color: #757575;
        }
      }
      span {
        cursor: pointer;
        b {
          color: $mainColor;
          padding: 0 2px;
        }
      }
      .iconfont {
        margin-right: 5px;
      }
      .icon-user {
        font-size: 14px;
      }
      .ru_zhu_icon {
        display: inline-block;
        width: 20px;
        height: 18px;
        background: url(../../../static/image/ru_zhu_black.png) no-repeat center;
        background-size: contain;
      }
      .ding_dan_icon {
        display: inline-block;
        width: 20px;
        height: 18px;
        background: url(../../../static/image/ding_dan_black.png) no-repeat
          center;
        background-size: contain;
      }
      .mine_icon {
        display: inline-block;
        width: 20px;
        height: 18px;
        background: url(../../../static/image/mine_black.png) no-repeat center;
        background-size: contain;
      }
      .shopping_car_icon {
        display: inline-block;
        width: 20px;
        height: 18px;
        background: url(../../../static/image/shopping_car_black.png) no-repeat
          center;
        background-size: contain;
      }
      &.item-select {
        position: relative;
      }
      & > i {
        font-size: 20px;
        margin-top: -2px;
      }
      & > i:before {
        color: #757575;
      }

      .icon-The-shopping-cart,
      .icon-my {
        font-size: 20px;
        margin-top: -2px;
      }
      .icon-The-shopping-cart:before,
      .icon-my:before {
        color: #757575;
      }
      &:hover {
        background-color: #fff;
        i:before {
          color: #ff7800;
        }

        .cart-no-data,
        .cart-no-login {
          display: flex;
        }
        .cart-list,
        .user-box {
          display: block;
        }
        .hover-item {
          color: $mainColor;
        }
      }
    }
    .item:hover {
      .item_text {
        color: #ff7800;
      }
    }
  }
  .cart-box {
    position: absolute;
    top: 100%;
    background-color: #fff;
    z-index: 999;
    border-radius: 0px 0px 4px 4px;
    box-shadow: 0px 0px 24px 0px rgba(0, 0, 0, 0.06);
    .cartImgBox {
      img {
        width: 100%;
      }
    }
    &.cart-no-login {
      width: 100%;
      left: 0;
      height: 160px;
      display: none;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .btn {
        display: inline-block;
        padding: 0 15px;
        height: 26px;
        line-height: 26px;
        text-align: center;
        color: #fff;
        background-color: $mainColor;
        border-radius: 4px;
        margin-bottom: 40px;
      }
      .p {
        color: #666666;
        line-height: 1em;
      }
    }
    &.cart-no-data {
      width: 264px;
      height: 110px;
      left: 50%;
      margin-left: -132px;
      display: none;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      color: #666;
    }
    &.cart-list {
      width: 348px;
      left: 50%;
      margin-left: -174px;
      display: none;
      // padding: 10px;
      dl {
        margin-bottom: 10px;
        padding: 20px 10px 10px 10px;
        dt {
          float: left;
          cursor: pointer;
        }
        dd {
          margin-left: 54px;
          position: relative;
          padding-right: 60px;
          min-height: 42px;
          line-height: 21px;
          h4 {
            color: #333;
            cursor: pointer;
            font-size: 14px;
            @include ellipsis;
          }
          p {
            color: #999;
            font-size: 14px;
            @include ellipsis;
          }
          span {
            color: $mainColor;
            position: absolute;
            top: 0;
            right: 0;
            font-size: 14px;
          }
          .btn-del {
            color: #333;
            position: absolute;
            top: 20px;
            right: 0;
            font-size: 14px;
          }
        }
      }
      .btn-view-all {
        display: inline-block;
        float: right;
        padding: 0 15px;
        height: 26px;
        line-height: 26px;
        text-align: center;
        color: #fff;
        background-color: $mainColor;
        border-radius: 4px;
        margin-top: 10px;
        cursor: pointer;
      }
    }
    &.user-box {
      width: 100%;
      left: 0;
      padding: 18px 0;
      display: none;
      li {
        font-size: 14px;
        display: block;
        cursor: pointer;
        color: #666;
        text-align: center;
        &:hover {
          background-color: #ffeee3;
        }
      }
    }
    .icon-xiaoxizhongxin:before {
      font-size: 22px;
      margin-left: -3px;
    }
  }
}
.QR-container {
  // width: 20%;
  // display: flex;
  // justify-content: flex-end;
  // align-items: center;
  text-align: center;
  & > div {
    margin-right: 20px;
    & > img {
      display: inline-block;
      height: 100px;
      margin: 0 auto;
    }
    & > div {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 12px;
      color: #666666;
      img {
        display: inline-block;
        height: 16px;
        margin-right: 4px;
      }
    }
  }
  & > div:last-child {
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/base_b2c/siteNav.vue